import { defaultBanksValue, defaultDashboardValue, defaultUserValue, defaultWorkspaceValue } from '@@types/defaultValues';
import { Bank, DashboardResponse, Order, Product, ProductCategory, Table, User, Workspace } from '@@types/index';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const adminTablesAtom = atom<Table[]>([]);
export const adminOrdersAtom = atom<Order[]>([]);
export const adminWorkspacesAtom = atom<Workspace[]>([]);
export const adminProductsAtom = atom<Product[]>([]);
export const adminCategoriesAtom = atom<ProductCategory[]>([]);
export const adminBanksAtom = atom<Bank[]>(defaultBanksValue);

export const adminDashboardAtom = atom<DashboardResponse>(defaultDashboardValue);
export const adminWorkspaceAtom = atomWithStorage<Workspace>('adminWorkspace', defaultWorkspaceValue, undefined, {
  getOnInit: true,
});

export const TABLE_VIEW = {
  LAYOUT: 'LAYOUT',
  LIST: 'LIST',
} as const;

export type TableView = typeof TABLE_VIEW[keyof typeof TABLE_VIEW];

export const adminTableViewModeAtom = atomWithStorage<TableView>('adminTableViewMode', TABLE_VIEW.LIST, undefined, {
  getOnInit: true,
});

export const adminUserAtom = atom<User>(defaultUserValue);

interface AcquisitionSurveyState {
  userId: number;
  isAnswered: boolean;
}

// userId를 함께 들고 있어야 같은 탭에서 계정을 바꿨을 때 앞 사람의 응답 여부가 남지 않는다.
// null은 '아직 확인 전'이다.
export const adminAcquisitionSurveyAtom = atom<AcquisitionSurveyState | null>(null);

export const adminUserAccountAtom = atom((get) => {
  const userInfo = get(adminUserAtom);
  const userAccount = userInfo.account;

  if (!userAccount) {
    return {
      bankName: '등록된 계좌가 없습니다.',
      accountNumber: '',
      accountHolder: '',
    };
  }

  const { bank, accountNumber, accountHolder } = userAccount;
  const { name: bankName, tossName: bankTossName } = bank;
  return { bankName, bankTossName, accountNumber, accountHolder };
});

export const adminUserTossAccountAtom = atom((get) => {
  const userInfo = get(adminUserAtom);
  const userTossAccountUrl = userInfo.account?.tossAccountUrl;

  if (!userTossAccountUrl) return null;

  const bankRegex = /bank=([^&]+)/;
  const accountNoRegex = /accountNo=([^&]+)/;
  const bankMatch = userTossAccountUrl.match(bankRegex);
  const accountNoMatch = userTossAccountUrl.match(accountNoRegex);

  if (!bankMatch || !accountNoMatch) return null;

  const [, bank] = bankMatch;
  const [, tossAccountNumber] = accountNoMatch;
  const tossBankName = decodeURIComponent(bank);

  return { tossBankName, tossAccountNumber };
});
